import React, { useState } from 'react';
import { Heading, Paragraph, Image } from '@piggybank/core';
import { withMagicUnderlines as links } from '@piggybank/core';
import styles from './offer-banner.module.css';
import PropTypes from 'prop-types';
import cn from 'classnames';

const calculateRatio = (x, y) => {
  return (x/y) * 100;
};

const OfferBanner = ({ background, onClick, textMap, url, targetValue }) => {
  const [isFocus, setFocus] = useState(false);
  const offerImgDim = {
    width: 1200,
    height: 396,
  };
  const offerImgRatio = calculateRatio(offerImgDim.height, offerImgDim.width);
  const offerImgIntrinsicSize = '100%x'+ offerImgRatio + '%';

  return (
    <div className={cn(styles.OfferBanner, [{ [styles.hasFocus]: isFocus }])}>
      <a className={cn(styles.Link, links.withMagicUnderlinesInverted)} href={url} onBlur={() => setFocus(false)} onClick={onClick} onFocus={() => setFocus(true)} target={targetValue}>
        <div className={cn(styles.Tile)}>
          {background.image &&
            <Image
              alt=""
              intrinsicSize={offerImgIntrinsicSize}
              src={background.image}
            />
          }
          {!background.image &&
          <div className={`${styles.NoBannerImage} ${styles[background.color || 'default']}`} />
          }
          <div className={styles.ContentBox}>
            {textMap.heading && <Heading component={'h2'} level={3}>{textMap.heading}</Heading>}
            <Paragraph marginBottom={0} small>{textMap.paragraph}{textMap.paragraph0 && <strong>{textMap.paragraph0}</strong>}</Paragraph>
            <Paragraph marginBottom={0} small>{textMap.paragraph1}</Paragraph>
            <Paragraph marginBottom={0} small>{textMap.paragraph2}{textMap.paragraph3 && <strong>{textMap.paragraph3}</strong>}</Paragraph>
          </div>
        </div>
      </a>
    </div>
  );
};

OfferBanner.displayName = 'OfferBanner';

OfferBanner.propTypes = {
  background: PropTypes.shape({
    color: PropTypes.string,
    image: PropTypes.string,
    size: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  textMap: PropTypes.shape({
    heading: PropTypes.string,
    paragraph: PropTypes.string.isRequired,
  }).isRequired,
  url: PropTypes.string,
  targetValue: PropTypes.string,
};

export default OfferBanner;
